module.exports = __webpack_public_path__ + "img/eu_belfor_logo.02fb1dcd.png";